import { useQuery } from "@tanstack/react-query";
import * as Api from "./bookings";

export function useGetBooking(bookingNumber: number){
  const result = useQuery<ReturnTypePromise<typeof Api.getBooking>, Error>(
    ['booking', bookingNumber],
    () => Api.getBooking(bookingNumber),
    {
      useErrorBoundary: false,
    }
  );

  return {...result, data: result.data};
}
